import React, { useState, useEffect, useRef } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import moment from "moment/moment";
import "../pagination/pagination.css";
import Pagination from "../pagination/pagination";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../services/apiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { ClipLoader } from 'react-spinners';
import { toast } from "react-toastify";
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import * as XLSX from "xlsx";

const RevenueAgainstInvoicesReport = () => {
    const apiService = new LeaseApiService();
    const gridRef = useRef();
    const { currencyPrecision } = useCurrency();
    const [rowData, setRowData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(50);
    const [pagination, setPagination] = useState();
    const [FilterTab, setFilterTab] = useState(true);
    const [propertyList, setPropertyList] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [formData, setFormData] = useState({
        property: { label: "All", value: "All" },
        unitNo: "",
        from: "",
        to: "",
    })
    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };
    useEffect(() => {
        fetchDropdownData();

        const today = new Date();

        const fromDate = new Date(today);
        fromDate.setFullYear(today.getFullYear() - 1);

        const toDate = new Date(today);
        toDate.setFullYear(today.getFullYear() + 0);

        setFormData((prev) => ({
            ...prev,
            from: formatDate(fromDate),
            to: formatDate(toDate),
        }));
    }, []);

    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    };
    const dateFormatter = (params) => {
        if (!params.value) return '';
        const date = moment(params.value);
        return date.isValid() ? date.format('DD-MMM-YYYY') : '';
    };
    const amountFormatter = (params) => {
        if (params?.value === null || params?.value === undefined) return '';
        return Number(params.value).toFixed(currencyPrecision?.decimalNumbers || 2);
    };

    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LRAgreeSearchProperties,');
            const res = await apiService.getApiParamater('REPORT_MULTI_DROP', `?${params.toString()}`);
            setPropertyList(res?.data?.dropdowns?.LRAgreeSearchProperties);
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoader(true)
            const today = new Date();
            let todate = formatDate(today)
            const oneYearBack = new Date();
            oneYearBack.setFullYear(today.getFullYear() - 1);
            const updatedValue = typeof oneYearBack === 'string' ? oneYearBack : formatDate(oneYearBack);
            const params = new URLSearchParams();
            params.append("PageNo", newPageNo || 1);
            params.append("PageSize", pageSize || 50);
            params.append("FromDate", formData?.from || updatedValue);
            params.append("ToDate", formData?.to || todate);
            params.append("PropertyNo", formData?.property?.value?.value || "All");
            params.append("UnitNo", formData?.unitNo?.label || "All");
            const res = await apiService.getApiParamater("REPORT_REVENUE_AGAINST_INVOICES", `?${params.toString()}`);
            if (res?.data?.result) {
                setRowData(res?.data?.result || []);
                setPagination(res.data.paginationData);
                getAllItems(res.data.paginationData)
                setLoading(false);
                setLoader(false)
            } else {
                setRowData(res?.data?.result || []);
                toast.error(res?.data?.message)
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching items:", error);
            setLoader(false)
            setLoading(false);
        }
    }
    const getAllItems = async (total) => {
        try {
            setLoader(true)
            const today = new Date();
            let todate = formatDate(today)
            const oneYearBack = new Date();
            oneYearBack.setFullYear(today.getFullYear() - 1);
            const updatedValue = typeof oneYearBack === 'string' ? oneYearBack : formatDate(oneYearBack);
            const params = new URLSearchParams();
            params.append("PageNo", 1);
            params.append("PageSize", total?.totalRecords);
            params.append("FromDate", formData?.from || updatedValue);
            params.append("ToDate", formData?.to || todate);
            params.append("PropertyNo", formData?.property?.value?.value || "All");
            params.append("UnitNo", formData?.unitNo?.label || "All");
            const res = await apiService.getApiParamater("REPORT_REVENUE_AGAINST_INVOICES", `?${params.toString()}`);
            if (res?.data?.result) {
                setExportData(res?.data?.result || []);
                setLoading(false);
                setLoader(false)
            } else {
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching items:", error);
            setLoading(false);
        }
    }
    const columnDefs = [
        { headerName: "S No", field: "s_No", filter: true, floatingFilter: true, suppressMovable: true, width: 90, pinned: "left" },
        { headerName: "Property No", field: "property_No", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
        { headerName: "Property Name", field: "property_Name", filter: true, floatingFilter: true, suppressMovable: true, width: 180 },
        { headerName: "Unit No", field: "unit_No", filter: true, floatingFilter: true, suppressMovable: true, width: 110 },
        { headerName: "Unit Type", field: "unit_Type", filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: "Lease No", field: "leaseNo", filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: "Tenant No", field: "tenant_No", filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: "Tenant Name", field: "tenant_Name", filter: true, floatingFilter: true, suppressMovable: true, width: 180 },
        { headerName: "Tenant Type", field: "tenant_Type", filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        {
            headerName: "Lease Start Date", field: "lease_Start_Date", filter: true, floatingFilter: true, suppressMovable: true, width: 150,
            valueFormatter: dateFormatter,
            comparator: dateComparator,
        },
        {
            headerName: "Lease Expiry Date", field: "lease_Expiry_Date", filter: true, floatingFilter: true, suppressMovable: true, width: 150,
            valueFormatter: dateFormatter,
            comparator: dateComparator,
        },
        {
            headerName: "Contracted Amount", field: "contracted_Amount", filter: true, floatingFilter: true, suppressMovable: true, width: 160,
            valueFormatter: amountFormatter,
        },
        { headerName: "Invoice No", field: "invoice_No", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
        {
            headerName: "Invoice Date", field: "invoice_Date", filter: true, floatingFilter: true, suppressMovable: true, width: 130,
            valueFormatter: dateFormatter,
            comparator: dateComparator,
        },
        { headerName: "Payment Type", field: "payment_Type", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
        { headerName: "Tax Rate", field: "tax_Rate", filter: true, floatingFilter: true, suppressMovable: true, width: 110 },
        {
            headerName: "Taxable Amount", field: "taxable_Amount", filter: true, floatingFilter: true, suppressMovable: true, width: 150,
            valueFormatter: amountFormatter,
        },
        {
            headerName: "VAT", field: "vat", filter: true, floatingFilter: true, suppressMovable: true, width: 110,
            valueFormatter: amountFormatter,
        },
        {
            headerName: "Total Invoice Amount", field: "total_Invoice_amount", filter: true, floatingFilter: true, suppressMovable: true, width: 170,
            valueFormatter: amountFormatter,
        },
        { headerName: "No Of Months In Invoice", field: "no_of_Months_in_Invoice", filter: true, floatingFilter: true, suppressMovable: true, width: 170 },
        {
            headerName: "Amount Posted In Prior Months", field: "amount_Posted_in_Prior_Months", filter: true, floatingFilter: true, suppressMovable: true, width: 200,
            valueFormatter: amountFormatter,
        },
        {
            headerName: "Amount Posted In Current Month", field: "amount_Posted_in_Current_Month", filter: true, floatingFilter: true, suppressMovable: true, width: 210,
            valueFormatter: amountFormatter,
        },
        {
            headerName: "Remaining Amount To Be Posted", field: "remaining_Amount_to_be_Posted", filter: true, floatingFilter: true, suppressMovable: true, width: 200,
            valueFormatter: amountFormatter,
        },
    ]
    const handleClearFilters = () => {
        setUnitList([])
        setRowData([])
        const today = new Date();
        const fromDate = new Date(today);
        fromDate.setFullYear(today.getFullYear() - 1);
        const toDate = new Date(today);
        setFormData({
            property: { label: "All", value: "All" },
            unitNo: "",
            from: formatDate(fromDate),
            to: formatDate(toDate),
        });
    }
    const handleDropDownChange = async ({ name, value }) => {
        if (name === "property") {
            setFormData(prev => ({ ...prev, unitNo: null }));
            const propertyValue = value?.value === 'All' ? null : value?.value;
            const params = new URLSearchParams();
            params.append('DropdownFor', 'LRAgreehUnitNosByPropertyId');
            params.append('CascadValue', propertyValue?.value);
            const res = await apiService.getApiParamater('REPORT_CASCAD', `?${params.toString()}`);
            setUnitList(res?.data?.items || []);
            setFormData(prev => ({ ...prev, [name]: value }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value);
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }
    const normalizeValue = (value) => {
        if (value === null || value === undefined) return "";
        if (value === 0 || value === "0") return "";

        if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)) {
            return moment(value).format("DD-MMM-YYYY");
        }

        return value;
    };
    const exportColumns = [
        { header: "S No", dataKey: "s_No" },
        { header: "Property No", dataKey: "property_No" },
        { header: "Property Name", dataKey: "property_Name" },
        { header: "Unit No", dataKey: "unit_No" },
        { header: "Lease No", dataKey: "leaseNo" },
        { header: "Tenant No", dataKey: "tenant_No" },
        { header: "Tenant Name", dataKey: "tenant_Name" },
        { header: "Lease Start Date", dataKey: "lease_Start_Date" },
        { header: "Lease Expiry Date", dataKey: "lease_Expiry_Date" },
        { header: "Contracted Amount", dataKey: "contracted_Amount" },
        { header: "Invoice No", dataKey: "invoice_No" },
        { header: "Invoice Date", dataKey: "invoice_Date" },
        { header: "Payment Type", dataKey: "payment_Type" },
        { header: "Tax Rate", dataKey: "tax_Rate" },
        { header: "Taxable Amount", dataKey: "taxable_Amount" },
        { header: "VAT", dataKey: "vat" },
        { header: "Total Invoice Amount", dataKey: "total_Invoice_amount" },
        { header: "Amount Posted In Prior Months", dataKey: "amount_Posted_in_Prior_Months" },
        { header: "Amount Posted In Current Month", dataKey: "amount_Posted_in_Current_Month" },
        { header: "Remaining Amount To Be Posted", dataKey: "remaining_Amount_to_be_Posted" },
    ];
    const exportPDF = () => {
        if (!exportData?.length) return;

        const doc = new jsPDF("landscape", "pt", "A4");

        doc.setFillColor(110, 81, 153);
        doc.rect(0, 0, doc.internal.pageSize.width, 50, "F");

        doc.setTextColor(255);
        doc.setFontSize(16);
        doc.text("Revenue Against Invoices Report", 40, 32);

        doc.setFontSize(9);
        doc.text(
            `Generated on: ${moment(formData?.to).format("DD-MMM-YYYY")}`,
            doc.internal.pageSize.width - 160,
            32
        );

        doc.setTextColor(0);

        doc.autoTable({
            startY: 60,
            head: [exportColumns.map(col => col.header)],
            body: exportData.map(row =>
                exportColumns.map(col => normalizeValue(row[col.dataKey]))
            ),
            styles: {
                fontSize: 8,
                cellPadding: 5,
                valign: "middle",
            },
            headStyles: {
                fillColor: [110, 81, 153],
                textColor: 255,
                fontStyle: "bold",
                halign: "center",
            },
            bodyStyles: {
                halign: "center",
            },
            alternateRowStyles: {
                fillColor: [240, 237, 245],
            },
            didDrawPage: data => {
                doc.setFontSize(8);
                doc.text(
                    `Page ${data.pageNumber}`,
                    doc.internal.pageSize.width / 2,
                    doc.internal.pageSize.height - 10,
                    { align: "center" }
                );
            },
        });
        doc.save("RevenueAgainstInvoicesReport.pdf");
    };
    const exportExcel = () => {
        if (!exportData?.length) return;

        const excelData = exportData.map(item => {
            const row = {};
            exportColumns.forEach(col => {
                row[col.header] = normalizeValue(item[col.dataKey]);
            });
            return row;
        });

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Revenue Against Invoices");
        XLSX.writeFile(workbook, "Revenue_Against_Invoices_Report.xlsx");
    };
    return (
        <div className="p-3">
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="form-group grid-contain ">
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Property </label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.property}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'property', value: selectedOption })}
                                    options={propertyList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Unit No </label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.unitNo}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'unitNo', value: selectedOption })}
                                    options={unitList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                        </div>
                        <div className="form-group grid-contain mt-3">
                            <div className="d-flex">
                                <label className="form-label">From</label>
                                <DatePicker
                                    selected={formData.from}
                                    onChange={(date) => handleDateChange({ name: 'from', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label w-0">To</label>
                                <DatePicker
                                    selected={formData.to}
                                    onChange={(date) => handleDateChange({ name: 'to', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100 datepicker-icon"
                                />
                            </div>
                            <div className="d-flex mt-2 gap-1">
                                {loader === true ?
                                    <div className='mainbtnGry flex-end gap-2 w-50'>
                                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                    </div>
                                    :
                                    <div
                                        onClick={() => getItems(1)}
                                        className="mainbtnGry flex-end gap-2 w-50"
                                    >
                                        <FaFileCircleExclamation
                                            color="#fff"
                                            className="center mt-2 mx-2"
                                        />
                                        <div className="center">Search</div>
                                    </div>
                                }
                                <div
                                    onClick={() => handleClearFilters()}
                                    className="mainbtnRed flex-end gap-2 w-50"
                                >
                                    <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="border-box2 p-3">
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className="d-flex justify-content-between">
                            <h5 className="col mainInvHead">Revenue Against Invoices Report</h5>
                            <button className="btn btn-primary" onClick={exportPDF}>
                                Export as PDF
                            </button>
                            <button className="btn btn-secondary mx-3" onClick={exportExcel}>
                                Export as Excel
                            </button>
                        </div>

                        <div className="gridshad mt-3">
                            <div className="ag-theme-quartz" style={{ height: 650 }}>
                                <AgGridReact
                                    ref={gridRef}
                                    getRowStyle={(params) => (params.node.rowIndex % 2 === 0 ? { background: "#F0EDF5" } : { background: "#fff" })}
                                    rowData={rowData}
                                    enableFilter={true}
                                    floatingFilter={true}
                                    columnDefs={columnDefs}
                                />
                            </div>
                            <Pagination
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                pagination={pagination}
                                getItems={getItems}
                            />
                        </div>
                    </>
                )}
            </div>
        </div >
    );
};
export default RevenueAgainstInvoicesReport;
